import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
// import { render } from "ink";

export default ({
  episode,
  guest,
  title,
  previewText,
  coverart,
  webheader,
}) => {
  // console.log("webheader: ", webheader);

  var episode_path =
    "/" +
    [
      "podcast",
      encodeURI(parseInt(episode)),
      encodeURI(guest.replace(/\s+/g, "-")),
      encodeURI(title.replace(/\s+/g, "-")),
    ].join("/");
  // console.log(episode_path);

  return (
    <>
      <article className="bb b--black-10 dn db-m db-l">
        <Link className="db pv3 ph0-l no-underline" to={episode_path}>
          {/* <p>Desktop</p> */}
          <div className="flex flex-row">
            <Img
              fixed={coverart.childImageSharp.fixed}
              className="w-third"
              alt="episode cover art"
            />

            <div className="pl3 dark-gray w-two-thirds  ">
              <h1 className="f3">
                Episode {episode} - {title}
              </h1>
              <p className="f6 f5-l lh-copy">{previewText}</p>

              <Link className="black f6 f5-l lh-copy" to={episode_path}>
                Read More...
              </Link>
            </div>
          </div>
        </Link>
      </article>
      <article className="bb b--black-10 dn-m dn-l">
        <Link className="db pv3 ph0-l no-underline" to={episode_path}>
          {/* <p>Mobile</p> */}
          <Img
            fluid={webheader.childImageSharp.fluid}
            className="center"
            alt="episode webheader"
          />

          <div className="pl3 dark-gray">
            <h1 className="f3">
              Episode {episode} - {title}
            </h1>
            <p className="f6 f5-l lh-copy">{previewText}</p>
            {/* <p className="f6 lh-copy mv0">By Daniel Holmlund</p> */}

            <Link className="black f6 f5-l lh-copy" to={episode_path}>
              Read More...
            </Link>
          </div>
        </Link>
      </article>
    </>
  );
};
